import NfsButton from "../../../genericComponents/NfsButton/NfsButton";
import "./FilterControl.css";
import { getNFSStatusName, NFSStatus } from "../../../../utils/nfsUtils";
import Toggle from "../../../genericComponents/Toggle/Toggle";

const allNFSStatuses = Object.values(NFSStatus).filter((status): status is NFSStatus => typeof status === "number");

interface FilterControlProps {
    filterEnabled: boolean;
    setFilterEnabled: React.Dispatch<React.SetStateAction<boolean>>;
    enabledNFSStatuses: NFSStatus[];
    setEnabledNFSStatus: React.Dispatch<React.SetStateAction<NFSStatus[]>>;
}
const FilterControl = ({
    enabledNFSStatuses,
    setEnabledNFSStatus,
    filterEnabled,
    setFilterEnabled,
}: FilterControlProps) => {
    return (
        <div className="filter-control">
            <span>
                Her kan du velge hvilke statuser som skal vises i kartet. Bruk knappene under for å slå statusene på
                eller av. Viser kun de markerte statusene.
            </span>
            <br />
            <div className="flex-row small-gap align-center w-100">
                <span>Aktiver filter</span>
                <Toggle
                    small
                    checked={filterEnabled}
                    onChange={() => {
                        setFilterEnabled(!filterEnabled);
                    }}
                />
            </div>
            <div className="filter-buttons">
                {allNFSStatuses.map((status) => {
                    return (
                        <NfsButton
                            key={status}
                            inverted
                            outlined
                            className="break-word h-stretch"
                            active={enabledNFSStatuses.includes(status)}
                            onClick={() => {
                                if (enabledNFSStatuses.includes(status)) {
                                    setEnabledNFSStatus(enabledNFSStatuses.filter((s) => s !== status));
                                } else {
                                    setEnabledNFSStatus([...enabledNFSStatuses, status]);
                                }
                            }}
                        >
                            {getNFSStatusName(status).replaceAll("/", "/\u200B")}
                        </NfsButton>
                    );
                })}
            </div>
        </div>
    );
};

export default FilterControl;
